import { createAsyncThunk, createSlice, current } from "@reduxjs/toolkit";
import {
  getBusinessOverViewDataGroupsv2,
  getBusinessOverViewDataTopExpenses,
} from "../../graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import { PURGE } from "redux-persist";

export const fetchBizViewData = createAsyncThunk(
  "dashboard/fetchBizViewData",
  async (
    {
      FinancialYearID,
      startDate,
      endDate,
      AccountGroupName,
      AccountTypeCD,
      DataRange,
      MonthValue,
      QuarterlyStartDate,
      QuarterlyEndDate,
      type,
    },
    { getState, dispatch }
  ) => {
    try {
      const groupDataResponse = await API.graphql(
        graphqlOperation(getBusinessOverViewDataGroupsv2, {
          businessOverViewInput: {
            FinancialYearID,
            AccountGroupName,
            AccountTypeCD,
            DataRange,
            MonthValue,
            QuarterlyStartDate:
              DataRange === "QUARTERLY" ? QuarterlyStartDate : 0,
            QuarterlyEndDate: DataRange === "QUARTERLY" ? QuarterlyEndDate : 0,
          },
        })
      );

      // const pandLDataResponse = await API.graphql(
      //   graphqlOperation(getBusinessOverViewDataPandL, {
      //     businessOverViewInput: {
      //       FinancialYearID,
      //       AccountGroupName,
      //       AccountTypeCD,
      //       DataRange,
      //       MonthValue,
      //       QuarterlyStartDate:
      //         DataRange === "QUARTERLY" ? QuarterlyStartDate : 0,
      //       QuarterlyEndDate: DataRange === "QUARTERLY" ? QuarterlyEndDate : 0,
      //     },
      //   })
      // );

      const topExpenseResponse = await API.graphql(
        graphqlOperation(getBusinessOverViewDataTopExpenses, {
          businessOverViewInput: {
            FinancialYearID,
            AccountGroupName,
            AccountTypeCD,
            DataRange,
            MonthValue,
            QuarterlyStartDate:
              DataRange === "QUARTERLY" ? QuarterlyStartDate : 0,
            QuarterlyEndDate: DataRange === "QUARTERLY" ? QuarterlyEndDate : 0,
          },
        })
      );
      const groupData =
        groupDataResponse.data?.getBusinessOverViewDataGroupsv2[0] || {};
      const transformedData = Object.keys(groupData)
        .filter(
          (key) =>
            key &&
            !["StartDate", "EndDate", "DataType", "__typename"].includes(key)
        )
        .map((key) => ({
          AccountGroupName: key,
          AccountTypeCD: "PandL",
          GroupBalance: groupData[key] !== null ? groupData[key] : 0,
          DataType: DataRange,
        }));
      const validExpenses =
        topExpenseResponse?.data?.getBusinessOverViewDataTopExpenses?.filter(
          (expense) => expense?.AccountGroupName !== null
        );
      let Data = [
        ...transformedData,
        // ...pandLDataResponse?.data?.getBusinessOverViewDataPandL,
        ...validExpenses,
      ];
      return {
        data: Data,
        startDate,
        endDate,
        DataRange,
        type,
      };
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
);

const INITIAL_STATE = {
  currentData: [],
  previousData: [],
  loadedData: {},
  loading: true,
  error: null,
  render: true,
  periodOptions: [
    { value: "fy", label: "This Financial Year" },
    { value: "month", label: "This Month" },
    { value: "quarter", label: "This Quarter" },
    { value: "half", label: "This Half" },
    { value: "custom", label: "Custom Date" },
  ],
  compareOptions: [],

  selectedPeriods: {
    period: {
      id: "fy",
      label: null,
      value: null,
    },
    comparison: {
      id: null,
      label: null,
      value: null,
    },
  },
};

const bizViewSlice = createSlice({
  name: "Bizview",
  initialState: INITIAL_STATE,
  reducers: {
    setPeriod: (state, action) => {
      const { key, sKey, value } = action.payload;
      state.selectedPeriods[key][sKey] = value;
      if (sKey === "value") {
        state.render = true;
      }
    },
    setResetPeriodComparison: (state, action) => {
      state.selectedPeriods.comparison =
        INITIAL_STATE.selectedPeriods.comparison;
    },
    setresetData: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
    setResetAllBiz: () => ({ ...INITIAL_STATE }),
    setcompareOptions: (state, action) => {
      state.compareOptions = action.payload;
    },
    setGroupData: (state, action) => {
      const { key, data } = action.payload;
      state[key] = state[key].filter(
        (item) =>
          !data.some(
            (newItem) => newItem.AccountGroupName === item.AccountGroupName
          )
      );
      state[key] = [...state[key], ...data];
    },
    // setRender: (state, action) => {
    //   state.render = action.payload;
    // },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBizViewData.fulfilled, (state, action) => {
        const { data, type } = action?.payload;
        // const filteredData = state[type].filter(
        //   (item) => item.AccountTypeCD !== "Top 5 Expenses"
        // );
        const updatedData = data;
        state[type] = updatedData;
        state.loading = false;
      })
      .addCase(fetchBizViewData.pending, (state, action) => {
        state.loading = true;
        state.render = false;
        // state.cards[action.meta.arg.id].render = false;
      })
      .addCase(fetchBizViewData.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(PURGE, () => INITIAL_STATE);
  },
});

export const {
  setPeriod,
  setcompareOptions,
  setresetData,
  // setRender,
  setResetAllBiz,
  setResetPeriodComparison,
  setGroupData,
} = bizViewSlice.actions;

export default bizViewSlice.reducer;
